// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2bed1509","64":"814b34e1","116":"e65f726d","162":"f718f667","462":"e5cd2afa","488":"857ae749","753":"a6d2712d","905":"004cefa1"}[chunkId] + ".chunk.js";
};